import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import { DatabaseService } from '../../services/database/database.service';
import { Database, TestConnectionResponse } from '../../../models/database';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subscription, finalize, interval } from 'rxjs';
import { AlertModalComponent } from '../../shared/alert-modal/alert-modal.component';
import { NgbModal, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { error } from 'console';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { EditDatabaseDetailsModalComponent } from '../../shared/edit-database-details-modal/edit-database-details-modal.component';
import { ToastService } from '../../services/toast/toast.service';
import { AddDatabaseModalComponent } from '../../shared/add-database-modal/add-database-modal.component';
import { LoadingServiceService } from '../../services/loadingService/loading-service.service';

@Component({
  selector: 'app-viewdatasrc',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbToastModule],
  templateUrl: './viewdatasrc.component.html',
  styleUrl: './viewdatasrc.component.scss',
  // changeDetection:ChangeDetectionStrategy.OnPush
})

export class ViewdatasrcComponent {
  databases: Database[] = [];
  private subscription: Subscription = new Subscription();
  index!: number;
  title!: string;
  //sessionID: string = ''

  constructor(
    private databaseService: DatabaseService,
    private modalService: NgbModal,
    public toastService: ToastService,
    private cdRef: ChangeDetectorRef,
    public loadService: LoadingServiceService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.loadService.show()
      this.loadDatabases();
      this.cdRef.detectChanges();
    }
  }

  loadDatabases(): void {
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.getDatabases().pipe(
      finalize(() => this.loadService.hide())
    ).subscribe((data) => {
      this.databases = data;
      this.cdRef.detectChanges();
      // console.log(data);
    });
  }

  openAddDatabaseModal() {
    const modalRef = this.modalService.open(AddDatabaseModalComponent, { size: 'xl', centered: true });
    modalRef.componentInstance.saved.subscribe(() => {
      this.loadDatabases();
      this.cdRef.detectChanges();
    })
  }

  openDeleteModal(dbName: any): void {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: 'lg', centered: false });
    modalRef.componentInstance.dbName = dbName;
    modalRef.result.then(
      (result) => {
        if (result === 'confirm') {
          this.removeDatabase(dbName);
          this.cdRef.detectChanges();
        }
      },
      () => { }
    );
  }

  removeDatabase(dbName: string): void {
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.deleteDatabase(dbName).subscribe({
      next: () => {
        this.loadDatabases(); // Refresh the list
        this.cdRef.detectChanges();
        this.toastService.showToast(`Database: ${dbName} is deleted successfully`, { classname: "bg-success text-light" })
      },
      error: (error) => {
        this.toastService.showToast(`Error deleting database with name: ${dbName}`, { classname: "bg-danger text-light" })
      },
    });
  }

  openEditModal(database: Database): void {
    const modalRef = this.modalService.open(EditDatabaseDetailsModalComponent, { centered: true });
    modalRef.componentInstance.database = database;
    modalRef.result.then(
      (updatedData) => {
        //const sessionID = sessionStorage.getItem('Session_Id')
        this.databaseService.updateDatabaseDetails(database.platform_name, updatedData).subscribe({
          next: () => {
            this.loadDatabases(); // Refresh the list
            this.cdRef.detectChanges();
            this.toastService.showToast(`Database with name:'${database.platform_name}' is updated successfully`, { classname: "bg-success text-light" })
          },
          error: (error) => {
            this.toastService.showToast(`Database with name:'${database.platform_name}' is not updated due to : ${error.message}`, { classname: "bg-danger text-light" })
          },
        });
      },
      () => { }
    );
  }

  testConnection(database: Database) {
    this.loadService.show()
    //const sessionID = sessionStorage.getItem('Session_Id')
    this.databaseService.testConnection(database.platform_name).pipe(
      finalize(() => this.loadService.hide())
    ).subscribe({
      next: (response: TestConnectionResponse) => {
        database.status = response.status
        this.cdRef.detectChanges();
        this.toastService.showToast(`Connection to ${database.platform_name} database establised successfully`, { classname: 'bg-success text-light' })

        setTimeout(() => {
          database.status = false;
          this.cdRef.detectChanges();
        }, 30 * 60 * 1000)
      },
      error: (error) => {

        let errorMessage = 'Error connecting to the database';
        if (error.error?.detail?.message) {
          // If we have a detailed message from the API
          errorMessage = error.error.detail.message;
        } else if (error.message) {
          // Fallback to generic error message
          errorMessage = error.message;
        }

        this.toastService.showToast(
          `Error connecting to ${database.platform_name}: ${errorMessage}`,
          { classname: 'bg-danger text-light' }
        );
      }
    })
  }

  getPlatformDisplayName(platform_type: string) {
    switch (platform_type) {
      case 'postgres':
        return 'PostgreSQL'
      case 'mysql':
        return 'MySQL'
      case 'snowflake':
        return 'Snowflake'
      default:
        return '';
    }
  }

  getDatabaseLogo(platform_type: string) {
    switch (platform_type) {
      case 'postgres':
        return '../../../../assets/images/postgresql.png'
      case 'mysql':
        return '../../../../assets/images/mysql.png'
      case 'snowflake':
        return '../../../../assets/images/snowflake.png'
      default:
        return '';
    }
  }
}
